import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { createGooglePayButton } from '../service'
import { googlePayDisabledSelector, googlePayPendingSelector } from '../selectors'
import { languageSelector } from 'i18n/selectors'
import CircleLoader from 'shared/components/CircleLoader'

import styles from './styles.module.scss'

const GooglePayButton = ({ disabled: disabledProp, isLoading: isLoadingProp, onClick, fallbackLabel }) => {
    const googlePayIsDisabled = useSelector(googlePayDisabledSelector)
    const googlePayPending = useSelector(googlePayPendingSelector)
    const locale = useSelector(languageSelector)

    const isLoading = googlePayPending || isLoadingProp
    const disabled = disabledProp || googlePayIsDisabled || isLoading

    const containerRef = useRef(null)

    useEffect(() => {
        if (!containerRef.current) return

        const container = containerRef.current
        container.innerHTML = ''

        try {
            const button = createGooglePayButton({ onClick, locale })
            container.appendChild(button)
        } catch (e) {
            // Keep container empty on failure;
        }

        return () => {
            container.innerHTML = ''
        }
    }, [locale, onClick])

    if (isLoading) {
        return <CircleLoader size="medium" className="mt-2" />
    }

    return <div ref={containerRef} className={classNames(disabled ? styles.disabled : '')} />
}

export default GooglePayButton
